import {
  Avatar,
  Button,
  CloseButton,
  CrudMode,
  DELETE_WARNING,
  DropDownMenu,
  ListContext,
  ListContextValue,
  MenuItemType,
  Stack,
  Typography,
  newToast,
} from "@compass/core";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SchoolIcon from "@mui/icons-material/School";
import { Permission, PermissionAction, Staff, StaffViewResource } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import { StaffTab } from "./StaffPage";
import { staffServicePageRoute } from "pages/staff/staff-services/StaffServicePage/StaffServicePage";

export const StaffPageHeader = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  reroute: (id: number, crudMode: CrudMode) => void;
  setCurrentTab: (tab: StaffTab) => void;
  staff: Staff;
  viewResource: StaffViewResource;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.staff.id;

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.staff.delete(id).then(() => {
        navigate("../");
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];

  if (isAuthorized(props.rootPermission, PermissionAction.Delete))
    menuItems.push({
      label: <Typography color="error">Delete</Typography>,
      action: () => postDelete(id),
    });

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Avatar string={`${props.staff.firstName} ${props.staff.lastName}`} size="large" />

        <Stack>
          <Stack direction="row" spacing="sm" alignItems="center">
            <Typography variant="h6">
              {props.staff.firstName} {props.staff.lastName}
            </Typography>
          </Stack>

          <Stack direction="row" spacing="md">
            <Stack direction="row" spacing="sm">
              <AccountBalanceIcon fontSize="small" opacity={0.3} />
              <Typography variant="caption">
                {props.viewResource.currentSchool ? props.viewResource.currentSchool : "No current school"}
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">

        <CloseButton confirm={props.unsavedChanges} />

        {props.crudMode === "view" && isAuthorized(Permission.StaffService, PermissionAction.Create) && (
          <Button
            onClick={() => {
              props.setCurrentTab("Services");
              navigate({
                pathname: staffServicePageRoute.getPath({
                  id: 0,
                  crudMode: "edit",
                  screenType: "dialog",
                }),
                search: staffServicePageRoute.getOptionalParams?.({
                  staffId: id,
                  hideStaff: true,
                }),
              });
            }}
            variant="outlined"
          >
            + Service
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
